// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12QN9","top":"styles_top__358b9"};